/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_Unavailable_ToastInputs */



/**
* | output |
* | --- |
* | "Frame cache requires desktop app with local video media" |
*
* @param {Pre_Render_Frame_Cache_Unavailable_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_unavailable_toast = /** @type {((inputs?: Pre_Render_Frame_Cache_Unavailable_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Unavailable_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le cache d'images nécessite l'application de bureau avec un média vidéo local")
	if (locale === "de") return /** @type {LocalizedString} */ ("Frame-Cache erfordert eine Desktop-Anwendung mit lokalen Videomedien.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La cache dei frame richiede un'applicazione desktop con supporti video locali.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для работы кэша кадров требуется настольное приложение с локальными видеофайлами.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La caché de fotogramas requiere la aplicación de escritorio con video local")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("帧缓存需要桌面应用程序和本地视频媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フレームキャッシュには、ローカルビデオメディアを備えたデスクトップアプリが必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ्रेम कैश के लिए स्थानीय वीडियो मीडिया के साथ डेस्कटॉप ऐप की आवश्यकता होती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O cache de quadros requer um aplicativo de desktop com mídia de vídeo local.")
	return /** @type {LocalizedString} */ ("Frame cache requires desktop app with local video media")
});